import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticatedHttpService } from './authenticatedhttp.service';

import { OrderInformation } from '../model/order-information';

@Injectable()
export class OrderInformationService {
    private baseUrl;

    constructor(
        private _http: AuthenticatedHttpService
    ) {
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    getOrderInfo(quoteId:number): Observable<OrderInformation> {
        return this._http.get(`${this.baseUrl}/api/quote/${quoteId}/orderInfo/`)
            .map(x => {
                let orderInfo = x.json();
                if (orderInfo !== undefined && orderInfo !== null) {
                    orderInfo.FinanceSources = (orderInfo.FinanceSources === undefined || orderInfo.FinanceSources === null
                        || orderInfo.FinanceSources[0] === undefined || orderInfo.FinanceSources[0] === null
                        || orderInfo.FinanceSources[0] === '' || !orderInfo.FinanceSources[0].charAt(0).match('[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]'))
                        ? new Array<string>('No Finance Flooring Source(s) Available')
                        : orderInfo.FinanceSources;

                    orderInfo.FreightCodes = (orderInfo.FreightCodes === undefined || orderInfo.FreightCodes === null
                        || orderInfo.FreightCodes[0] === undefined || orderInfo.FreightCodes[0] === null
                        || orderInfo.FreightCodes[0] === '' || !orderInfo.FreightCodes[0].charAt(0).match('[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]'))
                        ? new Array<string>('No Freight Code(s) Available')
                        : orderInfo.FreightCodes;
                    orderInfo.FinanceSource = orderInfo.FinanceSource !== undefined &&
                            orderInfo.FinanceSource !== null && orderInfo.FinanceSource !== ""
                        ? orderInfo.FinanceSource
                        : orderInfo.FinanceSource = "";
                    if (orderInfo.AdjustedSquareFootage === 0) { orderInfo.AdjustedSquareFootage = null; }
                    orderInfo.FreightOverride = (Number(orderInfo.FreightOverride) != 0)
                        ? this.checkTrailingZeros(orderInfo, orderInfo.FreightOverride)
                        : null;
                    orderInfo.SurchargeOverride = (Number(orderInfo.SurchargeOverride) != 0)
                        ? this.checkTrailingZeros(orderInfo, orderInfo.SurchargeOverride)
                        : null;
                    orderInfo.ModelBaseOverride = (Number(orderInfo.ModelBaseOverride) != 0)
                        ? this.checkTrailingZeros(orderInfo, orderInfo.ModelBaseOverride)
                        : null;
                } else {
                    //orderInfo = this.resetOrderInfo(quoteId, 0, '');
                    orderInfo = this.resetOrderInfo(quoteId, new OrderInformation());
                }
                return orderInfo;
            })
            .catch(this._http.handleError);
    }

    insertOrderInfo(orderInfo: OrderInformation): Observable<OrderInformation> {
        //let jsonBody = orderInfo;

        return this._http.put(`${this.baseUrl}/api/orderInfo`, JSON.stringify(orderInfo))
            .map(x => {
                let orderInfo: OrderInformation = x.json();
                if (orderInfo !== undefined && orderInfo !== null) {
                    orderInfo.FinanceSources = (orderInfo.FinanceSources === undefined || orderInfo.FinanceSources === null || orderInfo.FinanceSources.length === 0)
                        ? new Array<string>('No Finance Flooring Source(s) Available')
                        : orderInfo.FinanceSources;

                    orderInfo.FreightCodes = (orderInfo.FreightCodes === undefined || orderInfo.FreightCode === null || orderInfo.FreightCodes.length === 0)
                        ? new Array<string>('No Freight Code(s) Available')
                        : orderInfo.FreightCodes;

                    orderInfo.FinanceSource = orderInfo.FinanceSource !== undefined &&
                        orderInfo.FinanceSource !== null && orderInfo.FinanceSource !== ""
                        ? orderInfo.FinanceSource
                        : orderInfo.FinanceSource = "";

                    if (orderInfo.AdjustedSquareFootage === 0) { orderInfo.AdjustedSquareFootage = null; }
                    orderInfo.FreightOverride = (Number(orderInfo.FreightOverride) != 0)
                        ? this.checkTrailingZeros(orderInfo, orderInfo.FreightOverride)
                        : null;
                    orderInfo.SurchargeOverride = (Number(orderInfo.SurchargeOverride) != 0)
                        ? this.checkTrailingZeros(orderInfo, orderInfo.SurchargeOverride)
                        : null;
                } else {
                    //orderInfo = this.resetOrderInfo(orderInfo.QuoteId, 0, '');
                    orderInfo = this.resetOrderInfo(orderInfo.QuoteId, new OrderInformation());
                }
                return orderInfo;
            })
            .catch(this._http.handleError);
    }

    //resetOrderInfo(quoteId: number, orderInfoId: number, modifiedBy: string): OrderInformation {
    resetOrderInfo(quoteId: number, previousOrderInfo: OrderInformation): OrderInformation {
        let orderInfo = new OrderInformation();
        orderInfo.OrderInfoId = previousOrderInfo.OrderInfoId !== null ? previousOrderInfo.OrderInfoId : 0;
        orderInfo.QuoteId = quoteId;
        orderInfo.RetailerPickup = false;
        orderInfo.SalesNote = '';
        orderInfo.OrderedBy = '';
        orderInfo.AltConstruction = false;
        orderInfo.ModOffFrame = false;
        orderInfo.PerimiterBlocking = false;
        orderInfo.FinanceSource = '';
        orderInfo.FinanceSources = previousOrderInfo.FinanceSources;
        orderInfo.FreightCode = '';
        orderInfo.FreightCodes = previousOrderInfo.FreightCodes;
        orderInfo.RetailerShipTo = '';
        orderInfo.BaseAmount = null;
        orderInfo.AdjustedSquareFootage = null;
        orderInfo.SurchargeOverride = null;
        orderInfo.FreightOverride = null;
        orderInfo.SpecialInstructions = '';
        orderInfo.RetailerRequests = '';
        orderInfo.ModelBaseOverride = 0;
        orderInfo.ModifiedBy = previousOrderInfo.ModifiedBy;
        return orderInfo;
    }

	checkTrailingZeros(orderInfo: OrderInformation, value?, property?) {
		if (property) {
			if (isNaN(Number(value))) {
				value = 0;
				orderInfo[property] = value.toFixed(2).toString();
			} else {
				orderInfo[property] = Number(value).toFixed(2).toString();
			}
		}
		if (!property) {
			return value != null ? value.toFixed(2).toString() : '';
		}
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/order-information.service.ts